import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ReadWikisQueryVariables = {
  search?: Types.Maybe<Types.Scalars['String']>
};


export type ReadWikisQuery = (
  { __typename?: 'Query' }
  & { wikis: Array<(
    { __typename?: 'Wiki' }
    & Pick<Types.Wiki, '_id' | 'files' | 'deletionPeriod' | 'deletionRule' | 'filePreview' | 'tag' | 'topic' | 'body' | 'created' | 'modified' | 'inactive'>
    & { createdBy: Types.Maybe<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'upn' | 'firstName' | 'lastName' | 'name' | 'email' | 'department' | 'roles'>
    )>, modifiedBy: Types.Maybe<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'upn' | 'firstName' | 'lastName' | 'name' | 'email' | 'department' | 'roles'>
    )>, provingGround: Types.Maybe<(
      { __typename?: 'ProvingGround' }
      & Pick<Types.ProvingGround, '_id' | 'title'>
    )> }
  )> }
);

export const ReadWikisDocument = gql`
    query ReadWikis($search: String) {
  wikis(filter: {OR: [{topic: {REGEX: $search, OPTIONS: "i"}}, {tag: {REGEX: $search, OPTIONS: "i"}}], inactive: {NEQ: true}}, sort: {modified: ASC}) {
    _id
    files
    deletionPeriod
    deletionRule
    filePreview
    tag
    topic
    body
    created
    createdBy {
      _id
      type
      upn
      firstName
      lastName
      name
      email
      department
      roles
    }
    modified
    modifiedBy {
      _id
      type
      upn
      firstName
      lastName
      name
      email
      department
      roles
    }
    inactive
    provingGround {
      _id
      title
    }
  }
}
    `;

    export function useReadWikisQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadWikisQuery, ReadWikisQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadWikisQuery, ReadWikisQueryVariables>(ReadWikisDocument, baseOptions);
    };
      export function useReadWikisLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadWikisQuery, ReadWikisQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadWikisQuery, ReadWikisQueryVariables>(ReadWikisDocument, baseOptions);
      };
      
export type ReadWikisQueryHookResult = ReturnType<typeof useReadWikisQuery>;
export type ReadWikisQueryResult = ApolloReactCommon.QueryResult<ReadWikisQuery, ReadWikisQueryVariables>;